import { createEvent, createStore } from 'effector'

export const actions = {
  setUsers: createEvent<UserResponse[]>('setUsers'),
  resetUsers: createEvent('resetUsers'),
  reset: createEvent('reset'),
}

const initialState: UsersState = {
  users: [],
}

export const store = createStore<UsersState>(initialState, { name: 'users' })
  .on(actions.setUsers, (s, users) => ({ ...s, users }))
  .on(actions.resetUsers, (s) => ({ ...s, users: initialState.users }))
  .on(actions.reset, () => initialState)
